import {Component, ElementRef, AfterViewInit, Input} from "@angular/core";
import {ChangeTermsPurchaseField} from "./change-terms-purchase-field";
import { environment } from '../../../environments/environment';
import * as moment from 'moment-timezone';

@Component({
    selector: 'change-terms-purchase-row',
    templateUrl: './change-terms-purchase-row.component.html'
})

export class ChangeTermsPurchaseRowComponent implements AfterViewInit {

    @Input() field: ChangeTermsPurchaseField;
    public value: string;
    
    public constructor(private rootNode: ElementRef) {
    }

    ngAfterViewInit() {
        let that = this;
        if (this.field.type == 'datetime-local') {
            this.value = this.field.value ? moment(this.field.value, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss [(MSK+00:00)]') : '';
            $('.datetime', this.rootNode.nativeElement).daterangepicker({
                singleDatePicker: true,
                timePicker: true,
                timePicker24Hour: true,
                locale: {
                    applyLabel: 'Применить',
                    cancelLabel: 'Отменить',
                    format: 'DD.MM.YYYY HH:mm:ss' + ' (MSK' + environment.timezoneUserOffsetMsk + ')'
                },
                autoUpdateInput: false,
            }).on('change', function(e) {
                if ($(this).val()) {
                    $(this).trigger('apply.daterangepicker');
                } else {
                    $(this).trigger('cancel.daterangepicker');
                }
            });
            
            $('.datetime', this.rootNode.nativeElement).on('apply.daterangepicker', function(ev, picker) {
                $(this).val($(this).data('daterangepicker').startDate.format('DD.MM.YYYY HH:mm:ss') + ' (MSK' + environment.timezoneUserOffsetMsk + ')');
                that.field.value = moment($(this).val(), 'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

            });
            
            $('.datetime', this.rootNode.nativeElement).on('cancel.daterangepicker', function(ev, picker) {
                $(this).val('');
                that.field.change(ev.target);
            });
            
        } else if (this.field.type == 'date') {
            $('.date', this.rootNode.nativeElement).daterangepicker({
               singleDatePicker: true,
               timePicker: false,
               locale: {
                   format: 'DD.MM.YYYY'
               },
               autoUpdateInput: false,
            }).on('change', function(e) {
                if ($(this).val()) {
                    $(this).trigger('apply.daterangepicker');
                } else {
                    $(this).trigger('cancel.daterangepicker');
                }
            });
            
            $('.date', this.rootNode.nativeElement).on('apply.daterangepicker', function(ev, picker) {
                $(this).val($(this).data('daterangepicker').startDate.format('DD.MM.YYYY'));
                that.field.change(ev.target);
            });
            
            $('.date', this.rootNode.nativeElement).on('cancel.daterangepicker', function(ev, picker) {
                $(this).val('');
                that.field.change(ev.target);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/change-terms-purchase/change-terms-purchase-row.component.ts